import { Directive, Optional, ElementRef, HostListener, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pcgNumeric]'
    , standalone: false
})
export class NumericDirective {

    @Input('alignRight') alignRight: boolean = false;
	@Input('allowDecimal') allowDecimal: boolean = false;

	// Emitted when a non-numeric key is blocked, so callers can flash a "numbers only" hint
	// (mirrors the s2Numeric directive). Optional -- consumers that don't bind it are unaffected.
	@Output('pcgInvalidInput') invalidInput = new EventEmitter<void>();

	constructor(
        private elRef: ElementRef
        , @Optional() private control: NgControl
    ) { }

    @HostBinding('style.text-align') 
    get hostClasses(): string { return this.alignRight ? 'right' : ''; }

	@HostListener('keyup')
	keyEvent() { if (this.control) { this.control.control?.setValue(this.elRef.nativeElement.value); } }

	@HostListener('change')
	changeEvent() { if (this.control) { this.control.control?.setValue(this.elRef.nativeElement.value); } }

	@HostListener('keydown', ['$event'])
	onKeyDown(e: KeyboardEvent) {
		const isControlKey = [
			'Backspace', 'Tab', 'Delete', 
			'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'
		].includes(e.key);

		const isDigit = /^[0-9]$/.test(e.key);

		const isDecimal = this.allowDecimal && (e.key === '.');

		if (!isControlKey && !isDigit && !isDecimal) {
			this.invalidInput.emit();
			e.preventDefault();
			return false;
		}
	}
}
